<!--
  出水水质监测
-->

<template>
  <div class="water_quality">
    <ContentSection :title="'出水水质监测'" :mainStyle="{borderRightStyle:'solid',height:'25.617vh'}">
      <div class="qua_main">
        <ul class="content_list">
          <li  v-for="(item,index) in data" :key="index">
            <div class="border_top"></div>
            <div class="border_bottom"></div>
            <!-- 名称和数据部分 -->
            <div class="qua_info">
              <img :src="item.icon"/>
              <div>
                <p>{{item.value}}</p>
                <p class="qua_name">{{item.name}}</p>
              </div>
            </div>
            <!-- 比率 -->
            <!-- <span class="qua_radio">{{item.ratio}}</span> -->
          </li>
        </ul>
      </div>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from '@/components/ContentSection'
import { getLatestByConfig } from "@/api/basic.js"

  export default{
    name:'waterQuality',
    components:{
      ContentSection,
    },
    data(){
      return{
        data:[
          {
            name:'化学需氧',  // 名称
            value:'13.29 mg/l',  // 数据
            ratio:'100%',     // 比率
            icon:require('@/assets/img/water_quality0.png'),  // 图标
          },
          {
            name:'氨氮',
            value:'50.00 mg/l',
            ratio:'100%',
            icon:require('@/assets/img/water_quality1.png'),
          },
          {
            name:'总氮',
            value:'50.00 mg/l',
            ratio:'100%',
            icon:require('@/assets/img/water_quality2.png'),
          },
          {
            name:'总磷',
            value:'50.10 mg/l',
            ratio:'100%',
            icon:require('@/assets/img/water_quality3.png'),
          },
          {
            name:'PH',
            value:'14.00',
            ratio:'100%',
            icon:require('@/assets/img/water_quality4.png'),
          },
          {
            name:'悬浮物',
            value:'1000.00 mg/l',
            ratio:'100%',
            icon:require('@/assets/img/water_quality5.png'),
          },
          // {
          //   name:'氨氮',
          //   value:'4.00mg/l',
          //   ratio:'100%',
          //   icon:require('@/assets/img/water_quality6.png'),
          // },
          // {
          //   name:'石油类',
          //   value:'0.05',
          //   ratio:'100%',
          //   icon:require('@/assets/img/water_quality7.png'),
          // },
        ]
      }
    },
    mounted(){
      // this.setData()
    },
    methods:{
      // 获取值并赋给data对象，
    setData() {
      let data = {
        title: '',
        stagetype: 2,
        indicattype: 1
      }
      for (let i = 1; i <= 6; i++) {
        data.indicattype = i
        getLatestByConfig(data).then(res => {
          if (res.errorcode == 0) {
            let resData = res.resultdata.rows[0]
            console.log(resData)
            if(!resData.RealParamInfo){
              resData.RealParamInfo = {
                Value:0,
                Unit:resData.Unit
              }
            }
            if(resData.EquipmentName.includes('化学需氧量')){
              resData.RealParamInfo.name = '化学需氧量'
            }else if(resData.EquipmentName.includes('PH')){
              resData.RealParamInfo.name = 'PH'
            }else if(resData.EquipmentName.includes('悬浮物')){
              resData.RealParamInfo.name = '悬浮物'
            }else if(resData.EquipmentName.includes('氨氮')){
              resData.RealParamInfo.name = '氨氮'
            }else if(resData.EquipmentName.includes('总氮')){
              resData.RealParamInfo.name = '总氮'
            }else if(resData.EquipmentName.includes('总磷')){
              resData.RealParamInfo.name = '总磷'
            }
           this.data[i-1].name = resData.RealParamInfo.name
           this.data[i-1].value = resData.RealParamInfo.Value +' '+ resData.RealParamInfo.Unit
          }
        })
      }
    },
    }
  }
</script>

<style lang="less" scoped>
.water_quality{
  .qua_main{
    width: 100%;
    height: 100%;
    display: flex;
    .content_list{
      color: #fff;
      font-size: 40px;
      margin: auto;
      display: grid;
      grid-template-columns: repeat(2,396px);
      grid-gap: 19vh *@vh 18vw * @vw;
      // grid-template-rows: repeat(4,162.43vh * @vh);
      li{
        // background-image: linear-gradient(to right,rgba(0,143,255,0.55),rgba(0,78,140,0.55));
        background-image: radial-gradient(rgba(0,121,206,0.78),rgba(0,121,206,0));
        border-radius: 10vw * @vw;
        position: relative;
        display: flex;
        // width: 396px;
        height: 220px;
        &::before,
        &::after{
          content: '';
          width: 0;
          height: 0;
          display: inline-block;
          border: 15px solid #fff;
          border-top-color: transparent;
          border-bottom-color: transparent;
          border-right-color: transparent;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
        &::after{
          border-right-color: #fff;
          border-left-color: transparent;
          right: 0;
        }
        .border_top{
          width: 100%;
          height: 71px;
          border-radius: 10vw * @vw;
          border: 2vw*@vw solid #b4e6ff;
          border-bottom-color: transparent;
          position: absolute;
          top: 0;
        }
        .border_bottom{
          width: 100%;
          height: 71px;
          border-radius: 10vw * @vw;
          border: 2vw*@vw solid #b4e6ff;
          border-top-color: transparent;
          position: absolute;
          bottom: 0;
        }
        img{
          margin-right: 23px;
          margin-left: 23px;
        }
        &:nth-child(1) img{
          width: 101px;
          // height: 67vh * @vh;
        }
        &:nth-child(2) img,
        &:nth-child(3) img,
        &:nth-child(4) img,
        &:nth-child(5) img{
          width: 88px;
          // height: 59vh * @vh;
        }
        &:nth-child(6) img{
          width: 90px;
          // height: 67vh * @vh;
        }
        .qua_info{
          display: flex;
          align-items: center;
          text-align: left;
          p:first-child{
            font-size: 40px;
            font-family: PMZ;
          }
          .qua_name{
            font-size: 24px;
            color:#80c7ff;
          }
        }
        // 比率的样式
        .qua_radio{
          font-size: 24px;
          color:#80c7ff;
          position: absolute;
          top: 14vh * @vh;
          right: 19px;
        }
      }
      
    }
  }
}
@media screen and (min-width: 3640px),screen and(max-height: 1080) {
  .water_quality{
    .qua_main{
      .content_list{
        font-size: 22px;
        margin: auto;
        display: grid;
        grid-template-columns: repeat(2,255px);
        grid-gap: 19vh *@vh 30vw * @vw;
        li{
          height: 100px;
          img{
            margin-right: 23px;
            margin-left: 23px;
          }
          &:nth-child(1) img{
            width: 60px;
          }
          &:nth-child(2) img,
          &:nth-child(3) img,
          &:nth-child(4) img,
          &:nth-child(5) img{
            width: 48px;
          }
          &:nth-child(6) img{
            width: 50px;
          }
          .qua_info{
            p:first-child{
              font-size: 24px;
            }
            .qua_name{
              font-size: 16px;
            }
          }
        }
        
      }
    }
  }
}
</style>